import { Link } from "@areahub/ui";
import { Box, Button, ButtonProps } from "@chakra-ui/react";

export const AllEpisodesButton = ({
  link,
  ...buttonProps
}: ButtonProps & { link: string }) => {
  // Move margin up to top level so that the active link region isn't enlarged by it
  // Move display up so that it affects surrounding link
  const { m, mt, mb, ml, mr, mx, my, w, display, ...rest } = buttonProps;
  return (
    <Box {...{ m, mt, mb, ml, mr, mx, my, w, display }}>
      <Link href={link} _hover={{ textDecoration: "none" }}>
        <Button {...rest} />
      </Link>
    </Box>
  );
};
